import React from "react";
import ReactDOM from "react-dom";

import CountDownTimer from "../components/Counter/CountDownTimer";

const renderCountDownTimer = ($) => {
	const countDownTimer = $("#js-countDown-timer")[0];

	let props = {
		...(countDownTimer && countDownTimer.dataset),
	};

	if (countDownTimer) {
		ReactDOM.render(<CountDownTimer {...props} />, countDownTimer);
	}
};

export default renderCountDownTimer;
